import ModelUtil from '@leverege/model-util';
const TYPE = 'molten.MapViewerModel';
const STYLES = {
  vector: process.env.MAPBOX_VECTOR || 'mapbox://styles/mapbox/light-v10',
  satellite: process.env.MAPBOX_SATELLITE || 'mapbox://styles/mapbox/satellite-v9',
  dark: process.env.MAPBOX_DARK || 'mapbox://styles/mapbox/dark-v10',
  streets: process.env.MAPBOX_STREETS || 'mapbox://styles/mapbox/streets-v11',
  outdoors: process.env.MAPBOX_OUTDOORS || 'mapbox://styles/mapbox/outdoors-v11',
  satelliteStreets: process.env.MAPBOX_SATELLITE_STREETS || 'mapbox://styles/mapbox/satellite-streets-v11'
};

/**
 * This represents one source of a filter - a search bar, or a table for example.
 * The FilterSourcesModel will use these to create a single query, as well as to 
 * manage saving the filter states. Metadata is for use by the source.
 */
function create() {
  return {
    type: TYPE,
    // satellite, street, other
    mapStyle: null,
    customMapStyle: null,
    // maybe some flight controls here - jump to, fly to + time, etc
    layers: []
  };
}
function getMapStyleUrl(model, overrideStyle) {
  if (overrideStyle && STYLES[overrideStyle]) {
    return STYLES[overrideStyle];
  }
  if (STYLES[model?.mapStyle]) {
    return STYLES[model.mapStyle];
  }
  return model?.customMapStyle;
}
function getLayerByName(model, name) {
  return model.layers.find(l => l.layerName === name);
}
function getLayerIndexByName(model, name) {
  return model.layers.findIndex(l => l.layerName === name);
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('mapStyle'),
  ...ModelUtil.createAllValue('customMapStyle'),
  getMapStyleUrl,
  getLayerByName,
  getLayerIndexByName,
  ...ModelUtil.createAllArray('layers'),
  STYLES
};